import type { MessagesBoolExp } from "src/graphql";

export const MessageTabType = {
  ALL: "all",
  ONE_TIME: "one_time",
  RECURRING: "recurring",
  API_TRIGGERED: "api_triggered",
  JOURNEY: "journey",
} as const;

export type MessageTabType =
  (typeof MessageTabType)[keyof typeof MessageTabType];

export const JourneyMessageFilter: MessagesBoolExp = {
  journey_messages: {
    journey_node: { journey_version: { is_latest: { _eq: true } } },
  },
};

// Journey-triggered messages only: the latest journey version drives them, and
// `_not: { campaign: {} }` makes this source provably disjoint from the campaign
// rows (campaign-linked messages surface as their campaign, never here).
export const JOURNEY_MESSAGE_BASE: MessagesBoolExp[] = [
  JourneyMessageFilter,
  { _not: { campaign: {} } },
];

export const AllMessageFilter: MessagesBoolExp = {
  _or: [{ campaign: {} }, JourneyMessageFilter],
};

export const OneTimeMessageFilter: MessagesBoolExp = {
  campaign: { campaign_type: { _eq: "one_time" } },
};

export const RecurringMessageFilter: MessagesBoolExp = {
  campaign: { campaign_type: { _eq: "recurring" } },
};

export const ApiTriggeredMessageFilter: MessagesBoolExp = {
  campaign: { campaign_type: { _eq: "api_triggered" } },
};

export function getMessageTabFilter(tab: string | null): MessagesBoolExp {
  switch (tab) {
    case MessageTabType.ONE_TIME:
      return OneTimeMessageFilter;
    case MessageTabType.RECURRING:
      return RecurringMessageFilter;
    case MessageTabType.API_TRIGGERED:
      return ApiTriggeredMessageFilter;
    case MessageTabType.JOURNEY:
      return JourneyMessageFilter;
    case MessageTabType.ALL:
    default:
      return AllMessageFilter;
  }
}
